import { PrimaryButton } from '@/components/button/button-component';
import FormWrapper from '@/components/form-wrapper/form-wrapper-component';
import Link from '@/components/link/link-component';
import PageWrapper from '@/components/page-wrapper/page-wrapper-component';
import { BodyTextLarge, Heading1Text } from '@/utils/global-fonts';
import { FiChevronLeft } from 'react-icons/fi';
import styled from 'styled-components';

/**
 * Password reset confirmed page.
 * @returns {JSX.Element} The rendered Password reset confirmed page.
 */
const SentForgotPasswordEmail = () => (
  <PageWrapper>
    <Container>
      <BackIcon fontSize="20px" mr="12px" />
      <Link to="/login">Back</Link>
    </Container>
    <Heading1Text>Almost done!</Heading1Text>
    <FormWrapper
      defaultValues={{
        email: '',
      }}
      onSubmit={() => {}}
    >
      <BodyTextContainer>
        <BodyTextLarge>
          We have sent you further instructions. Please check your inbox You
          might need to check your spam folder too just to be safe.
        </BodyTextLarge>
      </BodyTextContainer>
      <ButtonContainer>
        <PrimaryButton
          buttonWidth="100%"
          buttonHeight="48px"
          type="submit"
          loading={false}
          title="RESEND EMAIL"
          onClick={() => {}}
        />
      </ButtonContainer>
    </FormWrapper>
  </PageWrapper>
);

const Container = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
`;

const BackIcon = styled(FiChevronLeft)`
  margin-right: ${({ mr }) => mr};
  font-size: ${({ fontSize }) => fontSize};
`;
const ButtonContainer = styled.div`
  margin-top: 40px;
`;
const BodyTextContainer = styled.div`
  margin-top: 24px;
`;

export default SentForgotPasswordEmail;
